import React from "react";
import "../styles.css";
import "../popup.css";
import "../try.css";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import { GiTBlogImg, HttpHeaderImg, MyBlogsImg } from "../imgs/images";

export default function BlogIntro() {
  return (
    <>
      <header className="quote-flex">
        <Fade right>
          {" "}
          <div className="quote">
            <span className="fs2rem">“</span>
            Life is an <span className="fs2rem">Open Source</span> Project,
            People will come, <span className="fs2rem"> Contribute, </span>
            Raise issues and there will be some unnecessary contributions too.
            But, It's you who is going to maintain it.
            <span className="fs2rem"> Merge </span> the positive changes and{" "}
            <span className="fs2rem"> Close </span> the negative ones.
            <span className="fs2rem">”</span>
            <div className="author-name">~ Zuber Dunge</div>
          </div>
          <img
            className="project-hero-img"
            src={MyBlogsImg}
            alt="Project Header Logo"
          />{" "}
        </Fade>
      </header>
      <h1 className="hero-heading blog-project-heading-big">
        Checkout<span className="blog-head"> My Blogs</span>
      </h1>
      <a href="#my-blogs">
        {" "}
        <div className="down-animatoin-margin">
          {" "}
          <div className="container-down">
            <div className="chevron"></div>
            <div className="chevron"></div>
            <div className="chevron"></div>
            {/* <span className="text">Scroll down</span> */}
          </div>
        </div>{" "}
      </a>

      <div id="my-blogs" className="project-grid">
        <Fade bottom>
          <div className="project-item">
            <img
              style={{ width: "100%" }}
              src="https://blog.zuberdunge.tech/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1650005651633%2F5VU_fnUyS.jpg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75"
              alt="batlist"
            />
            <h1 className="project-name-heading">
              {" "}
              batList - A watchlist extension for YouTube using ReactJS, Firebase, and YouTube API.

            </h1>
            <small>Published on April 15, 2022</small>

            <p>
              This blog is more about a project that is different from the rest of my projects and my journey of building it. This time I have tried my hands on building my very own chrome extension - BatList, a chrome extension for YouTube. I hope you all find it interesting too.
            </p>

            <div>
              <a
                href="https://blog.zuberdunge.tech/batlist-a-watchlist-extension-for-youtube"
                className="my-section-button"
              >
                Read Now
              </a>
            </div>
          </div>

          <div className="project-item">
            <img
              style={{ width: "100%" }}
              src="https://zuberdunge.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1641895026946%2FGUUA4Eujl.jpeg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75"
              alt="React Portfolio"
            />
            <h1 className="project-name-heading">
              {" "}
              What the fork is Arrow Function?
            </h1>
            <small>Published on January 11, 2022</small>

            <p>
              ES6 made our life easy with cool stuff like arrow functions,
              template literals, destructuring, JS modules, let - const, etc.
              These features allow us to write less do more. Today, we're gonna
              talk about brace yourselves the Arrow Functions.
            </p>

            <div>
              <a
                href="https://blog.zuberdunge.tech/wtf-arrow-functions"
                className="my-section-button"
              >
                Read Now
              </a>
            </div>
          </div>

          <div className="project-item">
            <img
              style={{ width: "100%" }}
              src="https://blog.zuberdunge.tech/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1638102631053%2FWuiH-khQm.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75"
              alt="React Portfolio"
            />
            <h1 className="project-name-heading">
              {" "}
              Building CryptoKnight - <br /> A ReactJS Project
            </h1>
            <small>Published on Nov 28, 2021</small>

            <p>
              {" "}
              In this blog, we’re going to build a crypto tracker app using
              ReactJS,CoinGecko API, MaterialUI, etc.
            </p>

            <div>
              <a
                href="https://zuberdunge.hashnode.dev/building-cryptoknight-using-react-js"
                className="my-section-button"
              >
                Read Now
              </a>
            </div>
          </div>

          <div className="project-item">
            <img
              style={{ width: "100%" }}
              src={GiTBlogImg}
              alt="React Portfolio"
            />
            <h1 className="project-name-heading">
              {" "}
              A Beginer Friendly Introduction to Git!
            </h1>
            <small>Published on Jun 18, 2021</small>

            <p>
              {" "}
              In this blog, we’re going to learn about Git, Some of the
              important Git Commands, Git Installation. Who created Git? why to
              use Git? which are the Git management services.
            </p>

            <div>
              <Link to="./GitIntro" className="my-section-button">
                Read Now
              </Link>
            </div>
          </div>

          <div className="project-item">
            <img
              style={{ width: "100%" }}
              src={HttpHeaderImg}
              alt="React Portfolio"
            />
            <h1 className="project-name-heading">
              {" "}
              A Complete Guide for HTTP Status Codes!
            </h1>
            <small>Published on Aug 15, 2021</small>

            <p>
              {" "}
              In this blog, we’re going to learn about 40+ HTTP status codes
              that you may get. From the 1XX- and 2XX-level codes to the
              trickier 4XX- and 5XX-level errors.
            </p>

            <div>
              <Link to="../HttpStatusCodes" className="my-section-button">
                Read Now
              </Link>
            </div>
          </div>
        </Fade>
      </div>
    </>
  );
}
